import React, {useState} from "react";
import {Card, Col, Row, Tabs, Tag} from "antd";
import {WalletSummary} from "./walletSummary/WalletSummary";
import {TabsContainer} from "./CourierWallet.styles";
import {CourierWalletSubTab} from "./courierWalletSubTab/CourierWalletSubTab";
import {useCourierWallet} from "./useCourierWallet";
import {CourierWalletInvoiceSubTab} from "./courierWalletInvoiceSubTab/CourierWalletInvoiceSubTab";
import {CourierWalletPaymentSubTab} from "./courierWalletPaymentSubTab/CourierWalletPaymentSubTab";
import {BlockWithdrawButton} from "./blockwithdrawButton/BlockWithdrawButton";
import {WalletStartDateButton} from "./walletStartDateButton/WalletStartDateButton";

export const CourierWallet = ({courierLoading, courier, canRender, reloadWallet}) => {
    const [subTabKey, setSubTabKey] = useState("courierWalletSubTab");
    const {wallet, walletLoading, refreshWallet} = useCourierWallet({
        courierLoading,
        courier,
        canRender,
        reloadWallet
    });

    const [walletStartDateRecall, setWalletStartDateRecall] = useState(false);

    return (
        <Card loading={courierLoading || walletLoading}>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <WalletSummary wallet={wallet} />
                </Col>
                {Boolean(wallet) && !walletLoading ? (
                    <Col span={24}>
                        <WalletStartDateButton
                            walletStartDate={wallet?.createdAt}
                            handleClick={() => setWalletStartDateRecall(!walletStartDateRecall)}
                        />
                        <Tag
                            color="blue"
                            style={{height: "100%", lineHeight: "30px", marginLeft: "8px"}}
                        >
                            Fatura Entegratörü: <b>{courier?.vendor || "-"}</b>
                        </Tag>
                    </Col>
                ) : (
                    <></>
                )}
                <Col span={24}>
                    <TabsContainer
                        onChange={setSubTabKey}
                        tabBarExtraContent={{
                            right: (
                                <BlockWithdrawButton
                                    wallet={wallet}
                                    reloadWallet={refreshWallet}
                                    walletLoading={walletLoading}
                                />
                            )
                        }}
                    >
                        <Tabs.TabPane
                            tab={<span data-testid="courierWalletSubTab">Cüzdan</span>}
                            key="courierWalletSubTab"
                        >
                            <CourierWalletSubTab
                                courier={courier}
                                walletData={wallet}
                                canRender={
                                    subTabKey === "courierWalletSubTab" &&
                                    !(courierLoading || walletLoading)
                                }
                                walletStartDateRecall={walletStartDateRecall}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane
                            tab={<span data-testid="courierWalletInvoiceSubTab">Fatura</span>}
                            key="courierWalletInvoiceSubTab"
                        >
                            <CourierWalletInvoiceSubTab
                                courier={courier}
                                canRender={
                                    subTabKey === "courierWalletInvoiceSubTab" &&
                                    !(courierLoading || walletLoading)
                                }
                                walletStartDate={wallet?.createdAt}
                                walletStartDateRecall={walletStartDateRecall}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane
                            tab={<span data-testid="courierWalletPaymentSubTab">Ödeme</span>}
                            key="courierWalletPaymentSubTab"
                        >
                            <CourierWalletPaymentSubTab
                                courier={courier}
                                canRender={
                                    subTabKey === "courierWalletPaymentSubTab" &&
                                    !(courierLoading || walletLoading)
                                }
                                walletStartDate={wallet?.createdAt}
                                walletStartDateRecall={walletStartDateRecall}
                            />
                        </Tabs.TabPane>
                    </TabsContainer>
                </Col>
            </Row>
        </Card>
    );
};
